import MuiLoadingButton from "@mui/lab/LoadingButton";
const LoadingButton = MuiLoadingButton;
export default LoadingButton;
